import { call, put, delay } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as actions from '../actions/stock';
import { get, post } from '../../utils/api';
import { errorModalOpen, getLocale } from '../../utils/functions';
import { modalErrorOpen } from '../actions/modalError';

export function* stock({ payload }) {
  let response = null;
  try {
    if (payload?.summary && !!payload.summary) {
      response = yield call(get, `/list/plants/${payload.id}/summary`);
    } else {
      response = yield call(get, `/list/plants/${payload.id}`);
    }
    yield put(actions.fetchStockSuccess(response));
  } catch (e) {
    yield put(actions.fetchStockFail(e.response?.data));
  }
}

export function* stockOptions({ payload }) {
  try {
    const response = yield call(get, `/plants/${payload.plantId}`);
    yield put(actions.fetchStockOptionsSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.fetchStockOptionsFail(error?.response?.data))
  }
}

export function* getSettingsPlantStorageTime({ payload }) {
  try {
    const response = yield call(get, `/settings/plant/storage_time?plant=${payload.plant}`);
    yield put(actions.getSettingsPlantStorageTimeSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getSettingsPlantStorageTimeFail());
  }
}

export function* setSettingsPlantStorageTime({ payload }) {
  try {
    yield call(
      post,
      `/settings/plant/storage_time?plant=${payload.plant}&storageTime=${payload.storageTime}`,
      null
    );
    yield put(actions.setSettingsPlantStorageTimeSuccess(payload.storageTime));
    notify(
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.setSettingsPlantStorageTimeFail());
  }
}

export function* sendFileStockSettings({ payload }) {
  try {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('plantId', payload.plantId);
    const response = yield call(
      post,
      '/piece/weight/correct',
      formData,
      {
        headers: {
          'Accept-Language': getLocale(),
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    yield put(actions.sendFileStockSettingsSuccess(response));

    notify(
      {
        message: 'Пожалуйста, подождите',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'info',
      2000
    );

    let varCount = 0;
    while (true) {
      yield delay(1000);
      if (varCount <= 100) {
        const res = yield call(
          get,
          `/piece/weight/correct?requestId=${response}`
        );
        if (res && res.status === 1) {
          yield put(actions.statusFileStockSettingsSuccess());
          notify(
            {
              message: 'Файл успешно обработан',
              height: 64,
              width: 354,
              position: {
                at: 'top center',
                my: 'top center',
                offset: '0 48'
              }
            },
            'success',
            2000
          );
          break;
        } else if (res.status === -1) {
          yield put(actions.statusFileStockSettingsFail());
          yield put(
            modalErrorOpen({
              message: 'Ошибка при обработке файла',
              techInfo: res.note,
              types: 'info',
              title: formatMessage('textError').warning
            })
          );
          break;
        }
      } else {
        yield put(actions.statusFileStockSettingsFail());
        yield put(
          modalErrorOpen({
            message: 'Превышен интервал ожидания',
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          })
        );
        break;
      }
      varCount += 1;
    }
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.sendFileStockSettingsFail());
  }
}
